<template>
  <div class="container">
    <div class="report-orgs-title"><span>相关部门举报机构</span></div>
    <div class="report-orgs-list">
      <a class="report-orgs-btn" href="https://www.12389.gov.cn/" target="_blank"
        >公安部<br /><strong>110</strong></a
      >
      <a class="report-orgs-btn" href="https://www.12321.cn/" target="_blank"
        >工信部<br /><strong>12321</strong></a
      >
      <a class="report-orgs-btn" href="http://jbts.mct.gov.cn/" target="_blank"
        >文化和旅游部<br /><strong>12318</strong></a
      >
      <a
        class="report-orgs-btn"
        href="http://www.shdf.gov.cn/shdf/channels/740.html"
        target="_blank"
        >"扫黄打非"办公室<br /><strong>12390</strong></a
      >
    </div>
  </div>
  <div class="footer">
    鄂州市公安局网络安全保卫支队小明国漫网安警务室<br />&copy;{{ year }}&nbsp;版权所有
    鄂ICP备2020016315号
  </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'NetaccuseFooter',
  data() {
    const year = new Date().getFullYear();
    return {
      year: `${year}-${year + 1}`
    };
  }
});
</script>
<style lang="scss" scoped>
.footer {
  margin-top: 40px;
  min-height: 120px;
  padding: 40px 20px;
  background-color: #eee;
  line-height: 1.5;
  font-size: 24px;
  color: #666;
  text-align: center;
}

.report-orgs-title {
  position: relative;
  margin: 80px 0 60px;
  // background: repeat-x center
  //   url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='20'%3E%3Cpath fill-rule='evenodd' fill='%2398BDFC' d='M9.776 19.672V.231h1.505v19.441H9.776zM5.224.231h1.505v19.441H5.224V.231zm-4.552 0h1.506v19.441H.672V.231z'/%3E%3C/svg%3E");
  color: #2f79f6;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  border-top: 2px solid #6ba9e6;
  vertical-align: top;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    // width: 450px;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 0 10px;
    &::before,
    &::after {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin: 0 10px;
      background: #fff url('../imgs/jt_right.png') no-repeat;
      background-size: cover;
      content: '';
    }
    &::before {
      transform: rotate(180deg);
    }
  }
}
.report-orgs-list {
  margin: 0 40px;
}
.report-orgs-btn {
  border-radius: 8px;
  border: 2px solid #cdeffd;
  box-shadow: 0px 0px 9.9px 0.1px rgb(5 157 254 / 32%);
  cursor: pointer;
  display: inline-block;
  font-size: 24px;
  min-width: 200px;
  padding: 20px;
  text-align: center;
  vertical-align: top;
  font-weight: normal;
  line-height: 1.5;
  margin: 0 3% 20px 0;
  width: 22.75%;
  background-color: #d8f4ff;
  color: #2f79f6;
  &:last-child {
    margin-right: 0;
  }
  strong {
    font-size: 40px;
  }
}
@media screen and (max-width: 640px) {
  .report-orgs-btn {
    margin: 0 10% 20px 0;
    width: 45%;
    &:nth-child(2) {
      margin-right: 0;
    }
  }
}
</style>
